<template>
  <div>
    <form
      method="POST"
      enctype="multipart/form-data"
      ref="media"
      @submit.prevent="onSubmitForm"
    >
      <div class="row mx-0">
        <div class="col p-0">
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <ActionButton
                  label="Choose file"
                  @customEvent="$refs.image.click()"
                  style="width: 100%; margin-top: 0;"
                  :theme="{ primary, secondary, event, danger }"
                  :disabled="loader"
                />
              </div>
              <div class="col-9">
                <input
                  @click="$refs.image.click()"
                  type="text"
                  v-model="fileName"
                  class="form-control"
                  style="cursor: pointer;"
                  readonly
                />
              </div>
              <div class="col-12">
                <span class="small text-danger" v-if="fileValidation">
                  Please upload file type: jpeg, jpg, png
                </span>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <ActionButton
                :theme="{ primary, secondary, event, danger }"
                type="submit"
                style="max-width: 7em; width: 100%; margin-top: 10px;"
                :label="null"
                :disabled="loader"
              >
                <Spinner v-if="loader" theme="currentColor" />
                <span v-else>Upload</span>
              </ActionButton>
            </div>
            <input
              class="col-8 col-sm-10 form-control d-none"
              ref="image"
              name="image"
              type="file"
              @change="handleFileChange"
              accept="image/png,image/jpg,image/jpeg"
              required
            />
          </div>
        </div>
      </div>
    </form>
    <div class="media-gallery">
      <template v-if="loading">
        <div class="media-gallery__loader">
          <Spinner :theme="primary" class="spinner" />
        </div>
      </template>
      <template v-for="obj of media">
        <div
          :key="obj.key"
          v-if="obj.size !== 0 && obj.photo.includes('medium')"
          class="media-gallery__item"
        >
          <img :src="obj.photo" :alt="obj.key" @click="handleClickImage(obj)" />
          <button @click="handleDeleteImage(obj)" class="-delete">
            <i class="fa fa-trash"></i>
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
/**
 * Media Gallery will emit @response with json object of the image
 */
import ActionButton from "@/components/ActionButton";
import mainAxios from "@/helpers/base";
import axios from "@/helpers/axios";
import Spinner from "@/components/Spinner";
import * as logger from "@/helpers/logger";
import { find } from "lodash";

export default {
  data() {
    return {
      media: [],
      loading: false,
      fileName: "",
      loader: false,
      fileValidation: false
    };
  },
  components: {
    Spinner,
    ActionButton
  },
  mounted() {
    this.handleListItems();
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    handleFileChange(e) {
      const file = e.target.files[0];
      const fileTypes = e.target.accept;

      if (!file) return;

      if (!file.type || !fileTypes.includes(file.type)) {
        this.$toastr.error(
          "Media selected is not supported. Only GIF, PNG, JPEG are allowed.",
          "Oops!"
        );
        this.reset();
        return;
      }

      this.fileName = file.name;
    },
    reset() {
      const input = this.$refs.image;
      input.type = "text";
      input.type = "file";
      this.fileName = "";
    },
    onSubmitForm() {
      this.loader = true;
      this.fileValidation = false;

      const form = new FormData(this.$refs.media);
      let type = "";
      const image = [
        "heic",
        "heif",
        "jpeg",
        "jpg",
        "png",
        "raw",
        "tiff",
        "webp",
        "mp4"
      ];
      for (let values of form.values()) {
        type = values.type;
      }
      if (image.includes(type.replace("image/", ""))) {
        mainAxios({
          cache: false,
          contentType: "multipart/form-data",
          data: form,
          method: "post",
          processData: false,
          url: "/media"
        })
          .then(async () => {
            this.$toastr.success("Image upload success!", "Success");
            this.reset();
            await this.handleListItems();
          })
          .finally(() => {
            this.loader = false;
          });
      } else {
        this.fileValidation = true;
        this.loader = false;
      }
    },
    handleListItems() {
      return new Promise((resolve, reject) => {
        axios
          .get("/media")
          .then(response => {
            this.media = response.data.data;
            resolve(true);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    async handleClickImage(obj) {
      await this.handleListItems();
      const chosenImage = JSON.parse(JSON.stringify(obj));
      if (find(this.media, chosenImage)) {
        this.$swal({
          title: "Confirm Upload",
          text: "Click choose to upload image",
          type: "info",
          showCancelButton: true,
          confirmButtonText: "Choose",
          reverseButtons: true
        }).then(async result => {
          if (result.value) {
            const images = {
              medium: obj.photo,
              original: obj.photo.replace("medium", "original"),
              thumbnail: obj.photo.replace("medium", "thumbnail")
            };
            this.$emit("response", images);
            this.close();
          }
        });
      } else {
        this.$swal("Warning", "Image is not available", "warning");
      }
    },
    handleDeleteImage(obj) {
      this.$swal({
        title: "Delete image?",
        text: "Do you want to delete this image",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete",
        reverseButtons: true
      }).then(async result => {
        if (result.value) {
          this.loading = true;
          const sizes = ["thumbnail", "medium", "original"];
          const defaultSize = "medium";
          for (var size of sizes) {
            await axios
              .post("/media/delete", {
                key: obj.key.replace(defaultSize, size)
              })
              .then(async () => {
                await this.handleListItems();
              })
              .catch(error => {
                logger.error(error);
              });
          }
          this.loading = false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.btn {
  font-size: $font-size-xs;
  margin-top: 10px;
  padding: 8px 14px;
}
.font-size-xs {
  font-size: 12px !important;
}
.form-control {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.media-gallery {
  margin: 10px auto;
  max-width: 768px;
  column-gap: 10px;
  position: relative;
  &__loader {
    background-color: rgba(255, 255, 255, 0.8);
    font-size: 2rem;
    position: absolute;
    z-index: 1011;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;

    .spinner {
      display: block;
      bottom: 0;
      left: 0;
      margin: auto;
      position: fixed;
      right: 0;
      top: 0;
    }
  }
  &__item {
    background: #fff;
    border-radius: 8px;
    margin: 0 0 10px;
    overflow: hidden;
    position: relative;
    img {
      width: 100%;
      cursor: pointer;
      &::before {
        display: block;
        content: " ";
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        background: black;
      }
    }
    > .-delete {
      color: white;
      position: absolute;
      top: 0;
      right: 0;
      border: none;
      background: transparent;
      cursor: pointer;
    }
  }
}

@media only screen and (min-width: 1024px) {
  .media-gallery {
    column-count: 4;
  }
}

@media only screen and (max-width: 1023px) and (min-width: 768px) {
  .media-gallery {
    column-count: 3;
  }
}

@media only screen and (max-width: 767px) and (min-width: 540px) {
  .media-gallery {
    column-count: 2;
  }
}
</style>
